/**
 * 应用入口。
 *
 * 顺序有讲究：
 * 1. `hydrateTokens()` 必须在挂载前调用——它把 refresh token 从 localStorage 读进内存。
 *    放到组件里做的话，首屏那几个请求会先以"未登录"的身份发出去，然后被 40100 打回。
 * 2. `bootstrapAuth()` 不 await。等它完成再挂载会让首屏白屏一整个 RTT；
 *    而 `hydrated` 标志已经保证"加载中"不会闪成"未登录"。
 */

import { createApp } from 'vue';

import App from './App.vue';
import { bootstrapAuth } from './lib/auth-store';
import { hydrateTokens } from './lib/token-store';
import { router } from './router';
import './app/globals.css';

hydrateTokens();

const app = createApp(App);
app.use(router);
app.mount('#app');

// 挂载之后再恢复登录态：先让用户看到骨架屏，而不是一片空白。
void bootstrapAuth();
